import { ReceiptState } from 'src/types/redux';
import {
  FETCH_RECEIPT_FAILURE,
  FETCH_RECEIPT_REQUEST,
  FETCH_RECEIPT_SUCCESS,
  ReceiptActionType,
} from '../types/receiptTypes';

const initialState: ReceiptState = {
  error: '',
  loading: false,
  receiptData: [],
};

export const receiptReducer = (
  state = initialState,
  action: ReceiptActionType
): ReceiptState => {
  switch (action?.type) {
    case FETCH_RECEIPT_REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case FETCH_RECEIPT_SUCCESS:
      return {
        ...state,
        loading: false,
        receiptData: action?.payload,
      };
    case FETCH_RECEIPT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action?.payload,
      };
    default:
      return state;
  }
};
